import { render, staticRenderFns } from "./policy-EN.vue?vue&type=template&id=328d798d&"
import script from "./policy-EN.vue?vue&type=script&lang=js&"
export * from "./policy-EN.vue?vue&type=script&lang=js&"
import style0 from "./policy-EN.vue?vue&type=style&index=0&lang=less&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports